import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...values: ClassValue[]) { return twMerge(clsx(values)); }
export function initials(name: string) { return name.split(' ').filter(Boolean).slice(0, 2).map(p => p[0]).join('').toUpperCase(); }
export function relative(date: string) {
    const m = Math.max(0, Math.floor((Date.now() - Date.parse(date)) / 60000));
    if (m < 1)
        return 'Now';
    if (m < 60)
        return `${m}m`;
    if (m < 1440)
        return `${Math.floor(m / 60)}h`;
    if (m < 2880)
        return 'Yesterday';
    return new Date(date).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}
export function time(date: string) { return new Date(date).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' }); }
export function dateLabel(date: string) {
    const d = new Date(date);
    if (d.toDateString() === new Date().toDateString())
        return 'Today';
    if (d.toDateString() === new Date(Date.now() - 86400000).toDateString())
        return 'Yesterday';
    return d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
}
export const channelName: Record<string, string> = { whatsapp: 'WhatsApp', instagram: 'Instagram', email: 'Email', telegram: 'Telegram', sms: 'SMS' };
export function fileSize(size: number) { return size < 1024 ? `${size} B` : size < 1048576 ? `${Math.ceil(size / 1024)} KB` : `${(size / 1048576).toFixed(1)} MB`; }
